<template>
    <el-tag :type="type" size="medium" >{{status}}</el-tag>
</template>

<script>
export default {
  name: 'OrderTag',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    type () {
      switch (this.status) {
        case 'Draft':
          return 'success'
        case 'Approved':
          return ''
        case 'Voided':
          return 'danger'
        default:
          return ''
      }
    }
  }
}
</script>
